import Button from '@mui/material/Button';
import { setSampleJob } from 'hooks/useRunABJob';

const SampleSimulatedJobButton = ({ redirect }) => {
  const handleClickAB = () => {
    setSampleJob();
    redirect('/jobs/GX3WjL3ZghA0564B');
  };

  const removeAllSelect = () => {
    const selectedItems = document
      .getElementsByClassName('menu-selected');
    for (const item of selectedItems) {
      item.classList.remove('menu-selected');
    }
  };

  const handleClickQuantum = () => {
    removeAllSelect();
    const contentHeader = document.getElementById('quantum_coin_toss');
    contentHeader.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    redirect('#quantum_coin_toss');
  };

  return (
    <div>
      <Button type="primary" variant="contained" onClick={handleClickAB}> Run A + B </Button>
      <Button
        type="secondary"
        variant="contained"
        sx={{ marginLeft: '20px' }}
        onClick={handleClickQuantum}
      >
        Run Quantum instead ☝️
      </Button>
    </div>
  );
};

export default SampleSimulatedJobButton;
